var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('svg', {
    attrs: {
      "width": "200",
      "height": "200",
      "viewBox": "0 0 200 200",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('rect', {
    attrs: {
      "x": "70",
      "y": "60",
      "width": "60",
      "height": "80",
      "rx": "4",
      "fill": "#ffffff",
      "stroke": "#9e9e9e",
      "stroke-width": "2"
    }
  }), _c('rect', {
    attrs: {
      "x": "75",
      "y": "70",
      "width": "50",
      "height": "3",
      "fill": "#9e9e9e"
    }
  }), _c('rect', {
    attrs: {
      "x": "75",
      "y": "80",
      "width": "40",
      "height": "2",
      "fill": "#9e9e9e"
    }
  }), _c('rect', {
    attrs: {
      "x": "75",
      "y": "90",
      "width": "45",
      "height": "2",
      "fill": "#9e9e9e"
    }
  }), _c('rect', {
    attrs: {
      "x": "75",
      "y": "100",
      "width": "35",
      "height": "2",
      "fill": "#9e9e9e"
    }
  })]);

}
var staticRenderFns = []

export { render, staticRenderFns }